import { doGETRequest, doPOSTRequest, doPUTRequest } from "./Api";

// API objesini const ile tanımlıyoruz
export interface PendingBuyerResponse {
  success: boolean;
  data: {
    totalPages: number;
    page: number;
    size: number;
    count: number;
    buyers: any[]; // asıl liste
  };
}

const BuyerApprovalApi = {
  // Onay bekleyen tüm müşteri hesaplarını getir
  listPending: async (
    isNew: boolean | null = null,
    page: number = 1,
    size: number = 20,
    search: string = ""
  ): Promise<PendingBuyerResponse> => {
    try {
      const params = new URLSearchParams();
      if (isNew !== null) params.append("isNew", String(isNew));
      params.append("page", String(page - 1));
      params.append("size", String(size));
      if (search.trim()) params.append("search", search.trim());

      const response = await doGETRequest(`/pending-buyer?${params.toString()}`);
      const resp = response as any;

      return {
        success: resp.success,
        data: {
          totalPages: resp.data?.totalPages || 0,
          page: resp.data?.page || page,
          size: resp.data?.size || size,
          count: resp.data?.count || (resp.data?.buyers ? resp.data.buyers.length : 0),
          buyers: resp.data?.buyers || []
        }
      };
    } catch (err) {
      console.error(err);
      return {
        success: false,
        data: {
          totalPages: 0,
          page,
          size,
          count: 0,
          buyers: []
        }
      };
    }
  },

  // Tek bir müşteri detayını getir
  getPendingById: async function (id: number) {
    try {
      const response = await doGETRequest(`/pending-buyer/${id}`);
      return response;
    } catch (err) {
      console.error(err);
      return { success: false, data: null };
    }
  },

  // Müşteri onayla / oluştur / güncelle
  approve: async function (buyer: any) {
    try {
      if (buyer.isNew) {
        // Yeni müşteri → POST
        return await doPOSTRequest("/buyers/approve", buyer);
      } else {
        // Var olan müşteri güncelleme → PUT
        return await doPUTRequest("/buyers/approve", buyer);
      }
    } catch (err) {
      console.error(err);
      return { success: false };
    }
  }

};

export default BuyerApprovalApi;
